// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 85 ? "exceljs" : chunkId) + "-legacy." + {"85":"65c8fd84","132":"513c0f62","354":"b1a69bc6","418":"d6b6c026"}[chunkId] + ".js";
};